import { createContext, useContext, useEffect, useRef, useState } from "react";

export const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({
  children,
  referenceNo,
  timer,
  allDetails,
  agentCode,
  currentPage,
  encryptedText,
  HeaderSectionHeight,
}) => {
  const [journeyData, setJourneyData] = useState(null);
  const [journeyConfig, setJourneyConfig] = useState(null);
  const [selectedLanguageCode, setSelectedLanguageCode] = useState("");
  const [isStartingJourneyClick, setIsStartingJourneyClick] = useState(false)
  const [isCameraPermissionAllowed, setIsCameraPermissionAllowed] =
    useState(null);
  const [mediaError, setMediaError] = useState(null);
  const [isMicrophonePermissionAllowed, setIsMicrophonePermissionAllowed] =
    useState(null);
  const [isLocationPermissionAllowed, setIsLocationPermissionAllowed] =
    useState(null);
  const [formattedTime, setFormattedTime] = useState("10:00");
  const [isMeetingEnded, setIsMeetingEnded] = useState(false);
  const [screenshots, setScreenshots] = useState([]);
  const applicationNo = referenceNo;
  const currentPageRef = useRef()

  // PUBSUB STATES
  const [allPubsubData, setAllPubsubData] = useState(null);
  const [journeyConfigData, setJourneyConfigData] = useState(null);
  const [journeyPubsubData, setJourneyPubsubData] = useState(null);
  const [faceVerified, setFaceVerified] = useState(false);
  const [agreedData, setAgreedData] = useState(false);
  const [faceDetectError, setFaceDetectError] = useState(null);
  const [currentPageData, setCurrentPageData] = useState(null);
  const [mediaPermissionEror, setMediaPermissionError] = useState(null);
  const [isAgreeButtonClick, setIsAgreeButtonClick] = useState(null);
  const [isDisagreeButtonClick, setIsDisagreeButtonClick] = useState(null);
  const [isTimerRunningData, setIsTimerRunningData] = useState(false);
  const [timerData, setTimerData] = useState(0)
  const [runningTimeData, setRunningTimeData] = useState("10:00")
  const [selectedLang, setSelectedLang] = useState("")
  const [isVideoConsentStart, setIsVideoConsentStart] = useState(false)
  const [openVideoErr, setOpenVideoErr] = useState(false)
  const [openDeviceChange, setOpenDeviceChange] = useState(false)
  const [openVideoFailErr, setOpenVideoFailErr] = useState(false);
  const [openTextMatchErr, setOpenTextMatchErr] = useState(false);
  const [openErrorBox, setOpenErrorBox] = useState(false)
  const [openJourneyLimitBox, setOpenJourneyLimitBox] = useState(false)
  const [isAbortSignal, setIsAbortSignal] = useState(false)
  const [isJourneyEnded, setIsJourneyEnded] = useState(false)
  const endApiCalledRef = useRef()
  const [deviceData, setDeviceData] = useState({
    latitude: null,
    longitude: null,
    browserName: null,
    deviceName: null,
    network: null,
  });
  const [accuracy, setAccuracy] = useState(null)

  useEffect(() => {
    currentPageRef.current = currentPage
  }, [currentPage])

  return (
    <AppContext.Provider
      value={{
        referenceNo,
        journeyConfig,
        applicationNo,
        allDetails,
        journeyData,
        timer,
        agentCode,
        currentPage,
        selectedLanguageCode,
        isCameraPermissionAllowed,
        isMicrophonePermissionAllowed,
        isLocationPermissionAllowed,
        formattedTime,
        encryptedText,
        HeaderSectionHeight,
        isMeetingEnded,
        allPubsubData,
        faceVerified,
        agreedData,
        faceDetectError,
        currentPageData,
        mediaPermissionEror,
        isAgreeButtonClick,
        isDisagreeButtonClick,
        isTimerRunningData,
        journeyConfigData,
        journeyPubsubData,
        timerData,
        runningTimeData,
        selectedLang,
        isVideoConsentStart,
        openVideoErr,
        openVideoFailErr,
        isAbortSignal,
        deviceData,
        isStartingJourneyClick,
        isJourneyEnded,
        mediaError,
        openDeviceChange,
        openErrorBox,
        openJourneyLimitBox,
        screenshots,
        openTextMatchErr,
        currentPageRef,
        accuracy,

        setJourneyData,
        setJourneyConfig,
        setSelectedLanguageCode,
        setIsCameraPermissionAllowed,
        setIsMicrophonePermissionAllowed,
        setIsLocationPermissionAllowed,
        setFormattedTime,
        setIsMeetingEnded,
        setAllPubsubData,
        setFaceVerified,
        setAgreedData,
        setFaceDetectError,
        setCurrentPageData,
        setMediaPermissionError,
        setIsAgreeButtonClick,
        setIsDisagreeButtonClick,
        setIsTimerRunningData,
        setJourneyConfigData,
        setJourneyPubsubData,
        setTimerData,
        setRunningTimeData,
        setSelectedLang,
        setIsVideoConsentStart,
        setOpenVideoErr,
        setOpenVideoFailErr,
        setIsAbortSignal,
        setDeviceData,
        setIsStartingJourneyClick,
        setIsJourneyEnded,
        setMediaError,
        setOpenDeviceChange,
        setOpenErrorBox,
        setScreenshots,
        setOpenTextMatchErr,
        endApiCalledRef,
        setAccuracy,
        setOpenJourneyLimitBox
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
